import { swSettings } from "app/common/services/swSettings";
import useLocalStorage from "app/custom-hooks/useLocalStorage";
import { openHooksModalV5 } from "app/services/ModalService";
import { allTrackers } from "app/services/track/track";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { getDateAsText } from "app/UtilitiesAndConstants/UtilityFunctions/timeAndDate";
import {
    isNoTouchOrTrialOrAfterTrial,
    isPendingTrialStatus,
    isSI,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import type { AIReportCtaPlacementValue } from "./AIReportCtaSection";

const AI_REPORT_CTA_SECTION_KEY = "ai-report-cta-section";

interface IUseAIReportCtaSectionApi {
    isShown: boolean;
    handleDismissClicked: () => void;
    handleTalkToUsClicked: () => void;
}

interface IUseAIReportCtaSectionProps {
    placement: AIReportCtaPlacementValue;
}

export const useAIReportCtaSection = ({ placement }: IUseAIReportCtaSectionProps): IUseAIReportCtaSectionApi => {
    const [isDismissedOnDate, setIsDismissedOnDate] = useLocalStorage(`${AI_REPORT_CTA_SECTION_KEY}-${placement}`);
    const hasFeature = GrowthbookService.growthbookInstance.getFeatureValue(TestsNames.AI_REPORT_CTA, false);

    const todayAsText = getDateAsText();

    const isEligible =
        hasFeature &&
        (isNoTouchOrTrialOrAfterTrial(swSettings) || isPendingTrialStatus(swSettings)) &&
        !isSI(swSettings);
    const isShown = isEligible && isDismissedOnDate !== todayAsText;

    const handleDismissClicked = () => {
        allTrackers.dispatchTrackEvent("internal link", "close", `AI recommendation report/${placement}`);
        setIsDismissedOnDate(todayAsText);
    };

    const handleTalkToUsClicked = () => {
        allTrackers.dispatchTrackEvent("internal link", "open", `AI recommendation report/${placement}`);
        void openHooksModalV5("ContactUs", undefined, "AI recommendation report", "GetLoading");
    };

    return { isShown, handleDismissClicked, handleTalkToUsClicked };
};
